// SupervisorDashboard tab IDs, region options, default filter values, route columns.
//
// NOTE: The LocationRoutes `market` field stores region codes (MW/NE/WC/S),
// and `fulfillmentCenter` stores city-level FC names like "Chicago".
// The UI labels Region (mapped to `market`) and Market (mapped to `fulfillmentCenter`)
// reflect the user-facing concepts, not the legacy field names.

export const TAB_IDS = {
  PLANNING: 'planning',
  ROUTE_OPERATIONS: 'route-operations',
  DISPATCH: 'dispatch',
  MONITORING: 'monitoring',
  EXCEPTION_REVIEW: 'exception-review',
};

// Dispatch Management renders only while the `supervisor-dashboard-dispatch`
// flag is on; SupervisorDashboard filters it out of this list otherwise.
export const TABS = [
  { id: TAB_IDS.PLANNING, label: 'Planning' },
  { id: TAB_IDS.ROUTE_OPERATIONS, label: 'Route Operations' },
  { id: TAB_IDS.DISPATCH, label: 'Dispatch Management' },
  { id: TAB_IDS.MONITORING, label: 'Monitoring' },
  { id: TAB_IDS.EXCEPTION_REVIEW, label: 'Exception Review' },
];

export const REGION_ALL = 'ALL';

export const REGIONS = [
  { value: REGION_ALL, label: 'All Regions' },
  { value: 'MW', label: 'MW' },
  { value: 'NE', label: 'NE' },
  { value: 'WC', label: 'WC' },
  { value: 'S', label: 'S' },
];

export const DATE_RANGE_LIMIT_DAYS = 31;
export const DEFAULT_DATE_RANGE_DAYS = 30;

// Single-day pickers. One day ahead covers PM stops that land on the next
// stocking date. The Dispatch lookback is a starting point pending Ops
// confirmation of how far back supervisors may update routes.
export const MONITORING_DATE_LOOKBACK_DAYS = 30;
export const DISPATCH_DATE_LOOKBACK_DAYS = 14;
export const SINGLE_DATE_LOOKAHEAD_DAYS = 1;

export const ROUTE_COLUMNS = [
  { key: 'stockingDate', label: 'Stocking Date', sortable: true, width: 130 },
  { key: 'market', label: 'Region', sortable: true, width: 90 },
  { key: 'fulfillmentCenter', label: 'Market', sortable: true, width: 160 },
  { key: 'route', label: 'Route', sortable: true, width: 190 },
  { key: 'stop', label: 'Stop', sortable: true, width: 80 },
  { key: 'stockingIndex', label: 'Stocking Index', sortable: true, width: 120 },
  { key: 'stopType', label: 'Stop Type', sortable: true, width: 110 },
  {
    key: 'toteCountPerStop',
    label: 'Totes / Stop',
    sortable: true,
    width: 110,
  },
  {
    key: 'toteCountPerRoute',
    label: 'Totes / Route',
    sortable: true,
    width: 110,
  },
  { key: 'onlineDate', label: 'Online Date', sortable: true, width: 130 },
  {
    key: 'stockedTimeUTC',
    label: 'Stocked Time UTC',
    sortable: true,
    width: 180,
  },
];
